<template>
  <div :class="wrapperClasses">
    <div class="listing">
        <a :href="csvDownloadLink" target="_blank" :download="true"><b-button v-if="hasDownloadLink" class="float-right" icon-left="download" icon-right="csv" title="Download CSV" rounded>CSV</b-button></a>
      <b-table :data="items" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column field="fulltName" label="first / last names" sortable>
            <a
              :href="props.row.identifier|mailto"
              :title="props.row.email|mailTooltip"
            >{{props.row.fullName}}</a>
          </b-table-column>
          <b-table-column field="active" class="check-column" label="Active" sortable>
            <b-icon v-if="props.row.active" icon="check" size="is-small " />
          </b-table-column>
          <b-table-column field="role" class="check-column" label="Role" sortable>{{props.row.role|toWords}}</b-table-column>
          <b-table-column
            field="createdAt"
            class="check-column"
            label="Joined"
            sortable
          >{{props.row.createdAt|shortDate}}</b-table-column>
          <b-table-column
            field="modifiedAt"
            class="check-column"
            label="Updated"
            sortable
          >{{props.row.modifiedAt|shortDate}}</b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { listSignUp } from "../api/methods";
import { mapUser } from "../api/mappers";
import filters from "../mixins/filters";
import { bus } from '../main';
import config from '../config/config';

export default {
  name: "SignUpList",
  components: {
  },
  mixins: [filters],
  data() {
    return {
      items: [],
      num: 0,
      csvDownloadLink: '',
    };
  },
  computed: {
    ...mapGetters(["settings", "options", "countries"]),
    wrapperClasses() {
      let cls = ["submissions"];
      if (this.showDetail) {
        cls.push("show-detail");
      }
      return cls;
    },
    computed() {
      return this.items.length;
    },
    hasDownloadLink() {
        return this.csvDownloadLink.length > 5;
    }
  },
  created() {
    this.loadUsers();
  },
  mounted() {
    bus.$on("refresh", () => {
      const { path } = this.$route;
      if (path.indexOf("signup") >= 0) {
        this.loadUsers();
      }
    });
  },
  methods: {
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      if (row.active) {
        cls.push("active");
      }
      return cls.join(" ");
    },
    loadUsers() {
      listSignUp().then(data => {
        if (data.items instanceof Array) {
          this.items = data.items.map(mapUser);
        }
      });
      this.csvDownloadLink = config.backendApi + 'user/signup-list-csv-download';
    }
  }
};
</script>